import { Box, Typography, SvgIcon, Divider, List, ListItem } from "@mui/material";
import { MobileDrawer } from "components/mobile-drawer/mobile-drawer";
import { MenuIcon } from "utils/constants";
import { useStyles } from "./nav-banner-style";
import { MenuData } from "utils/types";
import { useTranslation } from "react-i18next";

export interface NavBannerMobileProps {
  menuList: MenuData[];
  courseFinderDrawerOpen: boolean;
  setCourseFinderDrawerOpen: (smallDrawer: boolean) => void;
}

export const NavBannerMobile = ({
  menuList,
  courseFinderDrawerOpen,
  setCourseFinderDrawerOpen,
}: NavBannerMobileProps) => {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <MobileDrawer isOpen={courseFinderDrawerOpen} onVisibilityChange={setCourseFinderDrawerOpen}>
      <Box>
        <Typography className={classes.heading}>{t("available_subjects")}</Typography>
        {menuList.map((menu, idx) => (
          <Box key={idx}>
            {menu.header && (
              <Box className={classes.titleContainer}>
                <SvgIcon
                  component={MenuIcon[menu.header]}
                  className={classes.menuIconStyle}
                ></SvgIcon>
                <Typography className={classes.menuHeader}>{menu.header}</Typography>
              </Box>
            )}
            <Divider />
            <List>
              {menu.menuList.map((item) => (
                <ListItem key={item.id} className={classes.menuListItem}>
                  <a href={"/subjectarea/" + item.id}>{item.name}</a>
                </ListItem>
              ))}
            </List>
          </Box>
        ))}
      </Box>
    </MobileDrawer>
  );
};
